import PropTypes from 'prop-types';
// @mui
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
// hooks
import { useSiteContext } from 'src/components/site/context/site-context';

// ----------------------------------------------------------------------

export default function FrontSiteButton({ ...other }) {
  const { site } = useSiteContext();
  
  // サイト情報からフロントURLを構築
  const getFrontUrl = () => {
    if (!site) return null;

    if (site.expand_value.text.site_domain) {
      return `https://${site.expand_value.text.site_domain}`;
    }
    
    // domains配列の最初の要素を使用
    if (site.domains && site.domains.length > 0) {
      return `https://${site.domains[0]}`;
    }
    
    
    return null;
  };

  const frontUrl = getFrontUrl();

  const handleClick = () => {
    if (frontUrl) {
      window.open(frontUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <Tooltip title="WEBサイトを開く">
      <IconButton
        onClick={handleClick}
        disabled={!frontUrl}
        aria-label="open-front-site"
        {...other}
      >
        <Box
          component="img"
          src="/assets/icons/navbar/ic_external_grey.svg"
          alt="external-link"
          sx={{ width: 24, height: 24 }}
        />
      </IconButton>
    </Tooltip>
  );
}

FrontSiteButton.propTypes = {};
